import type { CardViewModel } from '@pesto/features/src/Cards/types/Cards.types';
import type { DropdownOption } from '@pesto/ui/components/DropdownInput';

import { deriveCardKind, isCurrentCard } from '@pesto/features/src/Cards/utils/deriveCardKind';
import { startCase } from '@pesto/utils';

const isCurrent = (card: CardViewModel) => isCurrentCard(deriveCardKind(card));

const toCardOption = (card: CardViewModel): DropdownOption => ({
  value: card.id,
  label: [
    card.referenceId ?? card.id,
    card.lastFour && `•••• ${card.lastFour}`,
    card.user?.name,
    !isCurrent(card) && startCase(card.status?.toLowerCase()),
  ]
    .filter(Boolean)
    .join(' · '),
});

export const toCardOptions = (cards: CardViewModel[]): DropdownOption[] =>
  [...cards.filter(isCurrent), ...cards.filter((card) => !isCurrent(card))].map(toCardOption);
